import React, { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import ImageInput from "./ImageInput";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { ContentState, SKAudioArtifact } from "../../../models/SKArtifact";
import { useNavigationBar } from "../../../context/NavigationContext";
import AudioInput from "./AudioInput";
import { useNavigate } from "react-router-dom";
import { FolderName } from "../../../api/shared/uploadService";

const CreateAudio = () => {
  const { contentData, artifactId, updateContentData, saveData, isEditable } = useContext(CreateArtifactContext);
  const [audioData, setAudioData] = useState<SKAudioArtifact | undefined>(undefined);

  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();
  // const [editable, setEditable] = useState<boolean>(true);
  // useEffect(() => {
  //   if (contentData.status === ContentState.DRAFT) {
  //     setEditable(true);
  //   } else {
  //     setEditable(false);
  //   }
  // }, [contentData]);

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add Audio",
      enableLink: contentData.status === ContentState.IN_REVIEW ? false : audioData?.audioURL && audioData.coverMedia?.coverImageURL ? true : false,
      getActionItems: undefined,
      onEdit: undefined,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
    }));
  }, [setNavProps, audioData, isEditable]);

  const submit = async () => {
    await saveData();
    navigate(-1);
  };

  useEffect(() => {
    setAudioData(contentData as SKAudioArtifact);
  }, [contentData]);

  const handleImageChange = (index: number, fileUrl: string | null) => {
    updateContentData({ coverMedia: { coverImageURL: fileUrl! } });
  };

  const handleAudioChange = (fileUrl: string | null) => {
    // if (fileUrl) {
    updateContentData({ audioURL: fileUrl });
    // } else {
    //   const { audioURL, ...rest } = contentData as SKAudioArtifact;
    //   updateContentData(rest);
    // }
  };

  return (
    <div className="flex flex-col gap-[30px] mt-[12px]">
      <div>
        <div className="flex flex-col">
          <div className="flex items-center">
            <span>
              <span className="content_count">1</span>
            </span>
            <span className="content_title">Add Audio</span>
          </div>
          <div className="notes-class-content">Maximum one audio of 90 minutes allowed.</div>
        </div>
        <AudioInput
          audioUrl={audioData?.audioURL}
          docId={artifactId!}
          onFileChange={fileUrl => {
            isEditable && handleAudioChange(fileUrl);
          }}
          editable={isEditable}
          removeAudio={isEditable ? () => handleAudioChange(null) : undefined}
          maxAudioDuration={5400} // 90 minutes
          maxFileSize={200} // 50 MB
          folder={FolderName.content}
        />
      </div>
      <div>
        <div className="flex flex-col">
          <div className="flex items-center">
            <span>
              <span className="content_count">2</span>
            </span>
            <span className="content_title">Add Audio Cover</span>
          </div>
          <div className="notes-class-content">
            Choose a photo that represents the topic, purpose or title of the audio. Recommended aspect ratio of photo is either 4:3, 1:1, or 3:4.
          </div>
        </div>
        <ImageInput
          key={0}
          index={0}
          onFileChange={handleImageChange}
          docId={artifactId!}
          maxFileSize={5}
          imageUrl={audioData?.coverMedia?.coverImageURL}
          editable={isEditable}
          folder={FolderName.content}
        />
      </div>
    </div>
  );
};

export default CreateAudio;
